import {remCalc} from '../../_utils'
import {getAssetUrl} from '@salesforce/pwa-kit-react-sdk/ssr/universal/utils'

const oldCss = {
    "[data-screenset-element-id='gigya-marketing-preferences-screen']": {
        '.gigya-layout-row.subscribe-wrapper': {
            display: 'flex',
            justifyContent: 'center',
            margin: '50px 0 20px',
            flexWrap: 'wrap',
            '.dln-page__sectionHeadTitle': {
                fontWeight: 700,
                fontStyle: 'normal',
                fontSize: '32px',
                lineHeight: '32px',
                margin: '0 0 33px 0',
                width: '100%',
            },
            '.dln-page__sectionHeadInfoText': {
                fontWeight: 400,
                fontStyle: 'normal',
                fontSize: '14px',
                lineHeight: '18px',
                width: '100%',
                marginBottom: '30px',
            },
            '.gigya-entitlement-checkbox': {
                position: 'relative',
                textAlign: 'center',
                minHeight: '130px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-end',
                padding: '20px',
                width: '100%',
                '&::before': {
                    content: "''",
                    position: 'absolute',
                    top: '30%',
                    display: 'block',
                },
                '.gigya-input-checkbox': {
                    margin: '3px',
                },
                '&.gigya-delonghi-checkbox::before,   &.gigya-nutribullet-checkbox::before': {
                    backgroundSize: '144px 46px',
                    backgroundRepeat: 'no-repeat',
                    width: '144px',
                    height: '46px',
                    top: '20%',
                    '@media only screen and (min-width: 600px)': {top: '30%'},
                },
                '&.gigya-nutribullet-checkbox::before': {
                    backgroundSize: '160px 26px',
                    backgroundRepeat: 'no-repeat',
                    width: '160px',
                    height: '26px',
                    top: '28%',
                    '@media only screen and (min-width: 600px)': {top: '35%'},
                },
                '&.gigya-braun-checkbox::before': {
                    backgroundSize: '108px 44px',
                    backgroundRepeat: 'no-repeat',
                    width: '108px',
                    height: '44px',
                    top: '20%',
                    '@media only screen and (min-width: 600px)': {top: '30%'},
                },
                '&.gigya-kenwood-checkbox::before': {
                    backgroundSize: '160px 24px',
                    backgroundRepeat: 'no-repeat',
                    width: '160px',
                    height: '24px',
                    top: '30%',
                    '@media only screen and (min-width: 600px)': {top: '37%'},
                },
                '.gigya-label': {
                    display: 'flex',
                    '.gigya-label-text': {marginTop: '3px'},
                },
                '@media (min-width: 600px)': {
                    minHeight: '180px',
                    maxHeight: '180px',
                    width: '45%',
                },
                '@media (min-width: 900px)': {width: '33.33%'},
                '@media (min-width: 1200px)': {width: '22%'},
            },
            '.gigya-visible-when': {
                width: '100%',
                '@media (min-width: 600px)': {
                    minHeight: '180px',
                    maxHeight: '180px',
                    width: '45%',
                },
                '@media (min-width: 900px)': {width: '33.33%'},
                '@media (min-width: 1200px)': {width: '22%'},
                '.gigya-entitlement-checkbox': {width: '100%'},
            },
        },
        '.gigya-delonghi-checkbox-sms, .gigya-braun-checkbox-sms, .gigya-kenwood-checkbox-sms, .gigya-nutribullet-checkbox-sms':
            {
                padding: '0 !important',
                margin: '0 !important',
                height: '20px !important',
                minHeight: '20px !important',
                left: 'calc(-50% - 1px) !important',
                top: '125px !important',
                width: '0 !important',
                '@media (min-width: 600px)': {
                    top: '175px !important',
                    left: 'calc(-22% - 5px) !important',
                },
                '@media (min-width: 900px)': {left: 'calc(-16% - 5px) !important'},
                '@media (min-width: 1200px)': {left: 'calc(-11% - 1px) !important'},
            },
        '.dln-btn--update': {
            textAlign: 'right',
            marginTop: '40px',
            paddingTop: '30px',
            width: '100%',
            input: {
                '@include gigya-dln-btn': true,
                width: '280px',
                fontWeight: 700,
                fontStyle: 'normal',
                fontSize: '14px',
                height: '40px',
            },
        },
    },
    '.dln-braun': {
        '.gigya-delonghi-checkbox-sms, .gigya-braun-checkbox-sms, .gigya-kenwood-checkbox-sms, .gigya-nutribullet-checkbox-sms':
            {
                display: 'none !important',
                left: 'calc(-50% - 2px) !important',
                '@media (min-width: 600px)': {
                    top: '175px !important',
                    left: 'calc(-22% - 7px) !important',
                },
                '@media (min-width: 900px)': {left: 'calc(-16% - 6px) !important'},
                '@media (min-width: 1200px)': {left: 'calc(-11% - 3px) !important'},
            },
    },
    '.dln-nutribullet': {
        '.gigya-delonghi-checkbox-sms, .gigya-braun-checkbox-sms, .gigya-kenwood-checkbox-sms, .gigya-nutribullet-checkbox-sms':
            {
                left: 'calc(-50% - 3px) !important',
                '@media (min-width: 600px)': {left: 'calc(-22% - 7px) !important'},
                '@media (min-width: 900px)': {left: 'calc(-16% - 7px) !important'},
                '@media (min-width: 1200px)': {left: 'calc(-11% - 3px) !important'},
            },
    },
    '.dln-kenwood': {
        '.gigya-layout-row.subscribe-wrapper': {
            '.gigya-label-text': {width: 'auto !important'},
            '.gigya-delonghi-checkbox-sms,  .gigya-braun-checkbox-sms,  .gigya-kenwood-checkbox-sms,  .gigya-nutribullet-checkbox-sms':
                {
                    left: 'calc(-50% - 4px) !important',
                    '@media (min-width: 600px)': {left: 'calc(-22% - 8px) !important'},
                    '@media (min-width: 768px)': {left: 'calc(-22% - 3px) !important'},
                    '@media (min-width: 900px)': {left: 'calc(-16% - 3px) !important'},
                    '@media (min-width: 1200px)': {left: 'calc(-11%) !important'},
                },
        },
    },
    '.gigya-layout-row:nth-child(4)': {
        display: 'flex',
        flexWrap: 'wrap',
        padding: '21px',
        borderColor: 'border.dark',
        borderStyle: 'solid',
        borderWidth: remCalc(1),
        '.gigya-custom-checkbox': {
            width: 'calc(100% - 30px)',
            margin: '0 !important',
            label: {
                fontWeight: 400,
                fontStyle: 'normal',
                fontSize: '13px',
            },
        },
        '.gigya-toggle': {
            width: '30px',
            textAlign: 'right',
            margin: '0 !important',
        },
        '.gigya-toggle-content': {
            fontSize: '11px',
            lineHeight: '16px',
            fontWeight: 400,
            fontStyle: 'normal',
            margin: '21px 0 0 !important',
        },
        '.is-hidden': {display: 'none !important'},
        '.dln-checkbox__confirmText': {
            marginTop: '30px',
            marginBottom: '20px',
            fontWeight: 700,
            fontStyle: 'normal',
            fontSize: '13px',
            lineHeight: '16px',
            width: '100%',
        },
        '.dln-btn--link': {
            width: '20%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
        },
        '.dln-btn--confirm': {
            width: '80%',
            display: 'flex',
            justifyContent: 'flex-end',
            input: {
                '@include gigya-dln-btn': true,
                width: '180px',
                fontWeight: 700,
                fontStyle: 'normal',
                fontSize: '14px',
                height: '40px',
                '@media (min-width: 600px)': {width: '280px'},
            },
        },
    },
    '.language-zh': {
        '#js-gigya-screenset-marketing-privacy': {
            '.gigya-screen-content': {
                '.gigya-profile-form': {
                    '>.gigya-layout-row:nth-of-type(2)': {
                        display: 'flex',
                        flexWrap: 'wrap',
                        padding: '21px',
                    },
                    '.gigya-layout-row:nth-child(4)': {display: 'none'},
                },
                '.gigya-toggle': {alignSelf: 'center'},
                '.dln-checkbox__confirmText': {
                    marginTop: '30px',
                    marginBottom: '20px',
                    fontWeight: 700,
                    fontStyle: 'normal',
                    fontSize: '13px',
                    lineHeight: '16px',
                    width: '100%',
                },
                '.dln-page__sectionHeadTitle': {
                    textAlign: 'center',
                    fontWeight: 700,
                    fontStyle: 'normal',
                    fontSize: '32px',
                    lineHeight: '32px',
                    margin: '0 0 33px',
                    width: '100%',
                },
                '.dln-page__sectionHeadInfoText': {
                    textAlign: 'center',
                    fontWeight: 400,
                    fontSize: '14px',
                    lineHeight: '18px',
                    width: '100%',
                    marginBottom: '30px',
                },
                '.dln-btn--link': {
                    width: '20%',
                    display: 'flex',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    fontWeight: 600,
                },
                '.dln-btn--confirm': {
                    width: '80%',
                    display: 'flex',
                    justifyContent: 'flex-end',
                    '.gigya-input-submit': {
                        width: '280px',
                        outline: 'none',
                        textAlign: 'center',
                        border: 'none',
                        boxShadow: 'none',
                        transition: 'all .3s linear',
                        overflow: 'hidden',
                        cursor: 'pointer',
                        height: '40px',
                    },
                },
                '.is-hidden': {display: 'none'},
                '.gigya-composite-control.gigya-composite-control-link.gigya-toggle': {
                    width: '30px',
                    textAlign: 'right',
                    margin: '0',
                },
                '.gigya-composite-control-link:focus': {border: 'none'},
                '.gigya-checkbox-text': {position: 'relative'},
            },
            '.gigya-layout-ro': {
                display: 'flex',
                justifyContent: 'center',
                margin: '50px 0 20px',
                flexWrap: 'wrap',
                '.gigya-entitlement-checkbox': {
                    position: 'relative',
                    textAlign: 'center',
                    minHeight: '130px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'flex-end',
                    padding: '20px',
                    width: '100%',
                    '.gigya-label-text.gigya-checkbox-text': {display: 'none'},
                    '&::before': {
                        content: "''",
                        position: 'absolute',
                        top: '30%',
                        display: 'block',
                    },
                    '.gigya-input-checkbox': {
                        position: 'absolute',
                        top: '-99999px',
                        left: '-99999px',
                        '+label': {
                            '&::before,      &::after': {position: 'relative'},
                            '&::after': {top: '-12px'},
                        },
                    },
                    '&.gigya-delonghi-checkbox::before,    &.gigya-nutribullet-checkbox::before': {
                        backgroundImage: "url('#{$pathAssets}/images/logos/logo-delonghi.svg')",
                        backgroundSize: '144px 46px',
                        backgroundRepeat: 'no-repeat',
                        width: '144px',
                        height: '46px',
                        top: '20%',
                        '@media only screen and (min-width: 600px)': {top: '30%'},
                    },
                    '&.gigya-nutribullet-checkbox::before': {
                        backgroundImage: "url('#{$pathAssets}/images/logos/logo-nutribullet.svg')",
                        backgroundSize: '160px 26px',
                        backgroundRepeat: 'no-repeat',
                        width: '160px',
                        height: '26px',
                        top: '28%',
                        '@media only screen and (min-width: 600px)': {top: '35%'},
                    },
                    '&.gigya-braun-checkbox::before': {
                        backgroundImage: "url('#{$pathAssets}/images/logos/logo-braun.svg')",
                        backgroundSize: '108px 44px',
                        backgroundRepeat: 'no-repeat',
                        width: '108px',
                        height: '44px',
                        top: '20%',
                        '@media only screen and (min-width: 600px)': {top: '30%'},
                    },
                    '&.gigya-kenwood-checkbox::before': {
                        backgroundImage: "url('#{$pathAssets}/images/logos/logo-kenwood.svg')",
                        backgroundSize: '160px 24px',
                        backgroundRepeat: 'no-repeat',
                        width: '160px',
                        height: '24px',
                        top: '30%',
                        '@media only screen and (min-width: 600px)': {top: '37%'},
                    },
                    '@media (min-width: 600px)': {
                        minHeight: '180px',
                        maxHeight: '180px',
                        width: '45%',
                    },
                    '@media (min-width: 900px)': {width: '33.33%'},
                    '@media (min-width: 1200px)': {width: '22%'},
                },
                '.gigya-visible-when': {
                    width: '100%',
                    '@media (min-width: 600px)': {
                        minHeight: '180px',
                        maxHeight: '180px',
                        width: '45%',
                    },
                    '@media (min-width: 900px)': {width: '33.33%'},
                    '@media (min-width: 1200px)': {width: '22%'},
                    '.gigya-entitlement-checkbox': {width: '100%'},
                },
                '.dln-btn--update': {
                    textAlign: ['right', 'center'],
                    marginTop: '40px',
                    paddingTop: '30px',
                    width: '100%',
                    input: {
                        '@include gigya-dln-btn': true,
                        width: '280px',
                        fontWeight: 700,
                        fontStyle: 'normal',
                        fontSize: '14px',
                        height: '40px',
                    },
                },
            },
        },
    },
    '.language-zh.dln-kenwood': {
        '#js-gigya-screenset-marketing-privacy': {
            '.gigya-input-submit': {backgroundColor: '#d11b59'},
            '.dln-btn--update': {paddingTop: '30px !important', textAlign: 'right'},
            '.gigya-screen-content': {
                '.gigya-profile-form': {
                    '>.gigya-layout-row:nth-of-type(2)': {
                        border: 'none',
                        borderBottom: '1px solid',
                    },
                    '.gigya-layout-row:nth-child(4)': {display: 'none'},
                },
            },
        },
    },
    '.dln-braun.language-zh': {
        '#js-gigya-screenset-marketing-privacy': {
            '.dln-page__sectionHeadTitle,  .dln-page__sectionHeadInfoText': {
                textAlign: 'left',
            },
            '.gigya-input-submit': {borderRadius: '20px'},
        },
    },
}

export default {
    baseStyle: () => {
        const braunLogo = getAssetUrl('static/img/marketing-preference/braun-logo.svg')
        const delonghiLogo = getAssetUrl('static/img/marketing-preference/delonghi.svg')
        const kenwoodLogo = getAssetUrl('static/img/marketing-preference/kenwood.svg')
        const nutribulletLogo = getAssetUrl('static/img/marketing-preference/nutribullet.svg')

        return {
            accountContainer: {
                w: '100%',
                paddingY: remCalc(100),
                paddingInline: {base: remCalc(16), md: remCalc(24)},
                paddingTop: {base: 0, md: remCalc(16), lg: remCalc(80)},
                gap: {base: remCalc(24)},
            },
            accountTitle: {
                textStyle: {base: 'head-large', lg: 'head-xlarge'},
                paddingBottom: {base: 0, sm: remCalc(24), md: 0},
                paddingY: {base: 0, lg: remCalc(24)},
                paddingTop: {base: remCalc(16), lg: remCalc(24)},
                fontWeight: 500,
                borderBottom: 'small',
                outline: 'none',
            },
            accountDetailContainer: {
                gap: {base: remCalc(12), sm: remCalc(24)},
            },
            accountDetailContent: {
                marginTop: {base: remCalc(12), lg: remCalc(0)},
                gap: {base: remCalc(24), lg: remCalc(40)},
            },
            personalInformationTitle: {
                textStyle: 'body-large',
                color: 'text.default',
                fontWeight: 700,
            },
            '.separator-wrapper': {
                height: remCalc(1),
                marginY: remCalc(30),
            },
            '.gigya-input-submit': {
                w: '100%',
                display: 'inline-flex',
                maxW: '100%',
                outlineWidth: 0,
                textStyle: 'body-medium',
                fontWeight: 'bold',
                alignItems: 'center',
                padding: `${remCalc(10)} ${remCalc(24)}`,
                maxHeight: remCalc(40),
                bg: 'button.background.primary-default',
                borderRadius: [
                    'button.radius.primary-default.base',
                    'button.radius.primary-default.sm',
                    'button.radius.primary-default.md',
                    'button.radius.primary-default.lg',
                ],
                '.gigya-style-modern div.gigya-screen-dialog-main': {
                    backgroundColor: 'background.default',
                    padding: remCalc(20),
                    maxwidth: remCalc(540),
                },
                '.gigya-style-modern div.gigya-screen-dialog-top': {
                    padding: 0,
                    border: 0,
                    lineHeight: 0,
                    backgroundColor: 'background.default',
                },
                color: 'button.text.primary-default',
                _hover: {
                    bg: 'button.background.primary-hover',
                },
                _focus: {
                    border: remCalc(2),
                    borderColor: 'button.border.primary-focused',
                    borderStyle: 'solid',
                    bg: 'button.background.primary-focused',
                },
                _disabled: {
                    bg: 'button.background.primary-disabled',
                    color: 'button.text.primary-disabled',
                    _hover: {
                        bg: 'button.background.primary-disabled !important',
                        color: 'button.text.primary-disabled',
                    },
                },
                _pressed: {
                    bg: 'button.background.primary-pressed',
                    color: 'button.text.primary-pressed',
                },
            },
            '.dlg-gigya-button-wrapper input[type=button], .dlg-gigya-button-wrapper input[type=submit]':
                {
                    outline: 'none',
                    textStyle: 'body-medium',
                    textAlign: 'center',
                    boxShadow: 'none',
                    transition: 'all .3s linear',
                    WebkitAppearance: 'none',
                    MozAppearance: 'none',
                    cursor: 'pointer',
                    WebkitUserSelect: 'none',
                    userSelect: 'none',
                    height: '40px',
                    padding: '0',
                    textDecoration: 'none',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                    borderRadius: [
                        'button.radius.primary-default.base',
                        'button.radius.primary-default.sm',
                        'button.radius.primary-default.md',
                        'button.radius.primary-default.lg',
                    ],
                    overflow: 'hidden',
                    maxWidth: remCalc(332),
                },
            '.gigya-password-input-container': {
                position: 'relative',
                width: '100%',
            },
            '.gigya-composite-control': {
                position: 'relative',
            },
            '.dlg-gigya-input-text-wrapper input': {
                borderRadius: '2px !important',
                border: 'small',
                borderStyle: 'solid',
                borderColor: 'border.dark',
                color: 'text.default',
                textStyle: 'body-small',
                outline: '0',
                width: '100%',
                lineHeight: '16px',
                backgroundColor: 'transparent !important',
                padding: '14px 8px 8px',
                boxSizing: 'border-box',
                appearance: 'none',
            },
            '.dlg-gigya-input-text-wrapper .gigya-label': {
                lineHeight: '150%',
                font: 'inherit',
                display: 'inline-block',
                color: 'text.secondary',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                transformOrigin: '0 0',
                transition:
                    'top .4s cubic-bezier(.25,.8,.25,1), transform .4s cubic-bezier(.25,.8,.25,1), color .4s cubic-bezier(.25,.8,.25,1), width .4s cubic-bezier(.25,.8,.25,1)',
                padding: '0 4px',
                overflow: 'hidden',
                pointerEvents: 'none',
                position: 'absolute',
                top: 'calc(50% - 21px)',
                left: '8px',
                zIndex: '1',
                textStyle: 'body-small',
            },
            '.dlg-gigya-input-text-wrapper.focus-visible + .gigya-label': {
                backgroundColor: 'background.default',
                transform: 'translateY(calc(50% - 29px)) scale(.75)',
            },
            '.gigya-composite-control-textbox:focus-within .gigya-label': {
                transform: 'translateY(calc(50% - 29px)) scale(0.75)',
                backgroundColor: 'background.default',
                color: 'border.dark',
            },
            '.gigya-composite-control-password:focus-within .gigya-label': {
                transform: 'translateY(calc(50% - 29px)) scale(0.75)',
                backgroundColor: 'background.default',
                color: 'border.dark',
            },
            '.gigya-spacer': {
                height: remCalc(24),
            },
            '.hr--solid:': {
                width: '100%',
                height: ' 1px',
                backgroundColor: 'border.light',
                margin: '24px 0',
            },
            '.dln-registrationForm__paragraph': {
                textStyle: 'body-small',
                color: 'text.default',
            },
            '.dlg-hidden': {
                display: 'none',
            },
            '.dln-completeForm__paragraph': {
                textStyle: 'body-xxsmall',
                lineHeight: '125%',
                width: ' 100%',
                color: 'text.default',
                margin: '0 0 16px',
            },
            '.dln-completeForm__paragraph--secondary': {
                textStyle: 'body-small',
                color: 'text.secondary',
                lineHeight: '125%',
                marginBottom: {base: remCalc(24), lg: remCalc(24)},
                display: 'inline-block',
            },
            '.dln-completeForm__paragraph--secondary:not(h2, label)': {
                display: 'flex',
                gap: remCalc(8),
                alignItems: 'center',
            },
            '.gigya-composite-control-checkbox .gigya-checkbox-text': {
                textStyle: 'body-small',
                fontWeight: '400',
                color: 'text.secondary',
                transition: 'color .12s linear',
            },
            '.dln-registrationForm__paragraph--secondary': {
                display: 'none',
            },
            '.gigya-composite-control.is-hidden': {
                display: 'none',
            },
            ...oldCss,
            '[data-screenset-element-id=gigya-marketing-preferences-screen] .gigya-layout-row.subscribe-wrapper .gigya-entitlement-checkbox.gigya-delonghi-checkbox::before':
                {
                    backgroundImage: `url("${delonghiLogo}")`,
                },
            '[data-screenset-element-id=gigya-marketing-preferences-screen] .gigya-layout-row.subscribe-wrapper .gigya-entitlement-checkbox.gigya-nutribullet-checkbox::before':
                {
                    backgroundImage: `url("${nutribulletLogo}")`,
                },
            '[data-screenset-element-id=gigya-marketing-preferences-screen] .gigya-layout-row.subscribe-wrapper .gigya-entitlement-checkbox.gigya-braun-checkbox::before':
                {
                    backgroundImage: `url("${braunLogo}")`,
                },
            '[data-screenset-element-id=gigya-marketing-preferences-screen] .gigya-layout-row.subscribe-wrapper .gigya-entitlement-checkbox.gigya-kenwood-checkbox::before':
                {
                    backgroundImage: `url("${kenwoodLogo}")`,
                },
            '.gigya-sms-disabled .gigya-delonghi-checkbox-sms': {
                display: 'none !important',
            },
            '.is-hidden': {display: 'none !important'},
        }
    },
}
